import { render, staticRenderFns } from "./IntegrationConfiguration.vue?vue&type=template&id=5367b1b9&"
import script from "./IntegrationConfiguration.vue?vue&type=script&lang=ts&"
export * from "./IntegrationConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports